import {} from './cookies/cookies_eu.js'
import {} from './cookies/banner_cookies.js'
